/*!
 * Offsure Product Card — colorway swatch swap (media + link) and the
 * quick-add size row reveal (desktop hover, mobile tap). Add-to-cart itself
 * is handled entirely by Horizon's native <product-form-component> (see
 * assets/product-form.js) — this file never touches the cart.
 */
(function () {
  if (window.__offsureProductCardReady) return;
  window.__offsureProductCardReady = true;

  function init(card) {
    if (card.__opcInit) return;
    card.__opcInit = true;

    var links = card.querySelectorAll('[data-opc-link]');
    var imgA = card.querySelector('[data-opc-img-a]');
    var swatches = Array.prototype.slice.call(card.querySelectorAll('[data-opc-swatch]'));
    var quickadd = card.querySelector('[data-opc-quickadd]');
    var metaEl = card.querySelector('[data-opc-meta]');
    var liveEl = card.querySelector('[data-opc-live]');
    var variants = [];
    try { variants = JSON.parse(card.querySelector('[data-opc-variants]').textContent); } catch (e) {}
    var colorIndex = Number(card.getAttribute('data-option-index'));
    var sheetColor = card.querySelector('[data-opc-sheet-colorway]');
    var sheetThumb = card.querySelector('[data-opc-sheet-thumb]');
    var hoverImage = card.querySelector('[data-opc-img-b]');
    var initialColor = metaEl ? metaEl.textContent.trim() : '';
    var titleText = (card.querySelector('.opc__title') || {}).textContent || '';
    titleText = titleText.trim();

    // Committed image = the swatch the shopper clicked (or the initial one).
    // Hover/focus previews swap img A temporarily and restore on leave.
    var committed = imgA ? { src: imgA.getAttribute('src'), srcset: imgA.getAttribute('srcset'), alt: imgA.getAttribute('alt') } : null;
    var hoverCapable = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function showImage(src, srcset) {
      if (!imgA || !src) return;
      if (srcset) imgA.setAttribute('srcset', srcset);
      else imgA.removeAttribute('srcset');
      imgA.setAttribute('src', src);
      imgA.style.objectFit = src.indexOf('offsure-curation-') !== -1 ? 'contain' : '';
    }
    function restoreCommitted() {
      if (!imgA || !committed) return;
      card.removeAttribute('data-opc-previewing');
      if (hoverImage) hoverImage.style.display = metaEl && metaEl.textContent.trim() === initialColor ? '' : 'none';
      if (committed.srcset) imgA.setAttribute('srcset', committed.srcset);
      else imgA.removeAttribute('srcset');
      imgA.setAttribute('src', committed.src);
      imgA.style.objectFit = committed.src.indexOf('offsure-curation-') !== -1 ? 'contain' : '';
      if (committed.alt != null) imgA.setAttribute('alt', committed.alt);
    }
    function preview(btn) {
      var img = btn.getAttribute('data-variant-image');
      if (!img || !imgA || btn.classList.contains('is-active')) return;
      card.setAttribute('data-opc-previewing', '');
      if (hoverImage) hoverImage.style.display = 'none';
      showImage(img, btn.getAttribute('data-variant-srcset'));
    }

    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-variant-url');
        var img = btn.getAttribute('data-variant-image');
        var srcset = btn.getAttribute('data-variant-srcset');
        var colorName = btn.getAttribute('data-color-name') || btn.getAttribute('aria-label');
        // Colorway grids keep one visible card for every product/color pair.
        // Swap the previous selection into the peer instead of duplicating it.
        var previousColor = metaEl ? metaEl.textContent.trim() : initialColor;
        var grid = card.closest('.odr-grid');
        if (grid && !grid.__opcSwapping && colorName !== previousColor) {
          var peer = Array.prototype.find.call(grid.querySelectorAll('opc-card[data-odr-piece]'), function (other) {
            var otherMeta = other.querySelector('[data-opc-meta]');
            return other !== card && other.getAttribute('data-product-id') === card.getAttribute('data-product-id') && otherMeta && otherMeta.textContent.trim() === colorName;
          });
          var replacement = peer && Array.prototype.find.call(peer.querySelectorAll('.opc__body [data-opc-swatch]'), function (swatch) {
            return swatch.getAttribute('data-color-name') === previousColor;
          });
          if (replacement) {
            grid.__opcSwapping = true;
            try { replacement.click(); } finally { grid.__opcSwapping = false; }
          }
        }
        var alt = colorName && titleText ? 'Offsure ' + titleText + ' in ' + colorName : null;
        card.removeAttribute('data-opc-previewing');
        if (img && imgA) {
          showImage(img, srcset);
          if (alt) imgA.setAttribute('alt', alt);
          committed = { src: img, srcset: srcset || null, alt: alt };
        }
        if (url) {
          links.forEach(function (a) { a.setAttribute('href', url); });
        }
        if (colorName) {
          if (metaEl) metaEl.textContent = colorName;
          if (sheetColor) sheetColor.textContent = colorName;
          if (sheetThumb && img) sheetThumb.setAttribute('src', img);
          // An alternate photo belongs to the original color only.
          if (hoverImage) hoverImage.style.display = colorName === initialColor ? '' : 'none';
          card.querySelectorAll('.opc__size-form').forEach(function (form) {
            var button = form.querySelector('button[type="submit"]');
            var input = form.querySelector('input[name="id"]');
            if (!button || !input || !variants.length) return;
            var size = button.textContent.trim();
            var variant = variants.find(function (v) {
              return v.options[colorIndex] === colorName && v.options[v.options.length - 1] === size;
            });
            var available = !!(variant && variant.available);
            input.value = variant ? variant.id : '';
            input.disabled = !available;
            button.disabled = !available;
            button.classList.toggle('is-soldout', !available);
          });
          if (liveEl) liveEl.textContent = 'Color changed to ' + colorName;
        }
        swatches.forEach(function (s) {
          var active = s.getAttribute('data-color-name') === colorName;
          s.classList.toggle('is-active', active);
          s.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
      if (hoverCapable) {
        btn.addEventListener('mouseenter', function () { preview(btn); });
        btn.addEventListener('mouseleave', function () { restoreCommitted(); });
      }
      btn.addEventListener('focus', function () { preview(btn); });
      btn.addEventListener('blur', function () { restoreCommitted(); });
    });

    // Mobile / touch: the media link navigates straight to the PDP; the
    // dedicated "+" button (data-opc-sheet-trigger) opens the real
    // dialog.js bottom sheet (see the <dialog-component> markup in
    // offsure-product-card.liquid) instead of an inline reveal.
  }

  var drawerOpenBound = false;
  function bindDrawerOpen() {
    if (drawerOpenBound) return;
    drawerOpenBound = true;
    document.addEventListener('cart:update', function () {
      // Close any open quick-add sheet first so the cart drawer isn't
      // stacked behind/over an already-open bottom sheet.
      document.querySelectorAll('dialog.opc-sheet[open]').forEach(function (dlg) {
        var host = dlg.closest('dialog-component');
        if (host && typeof host.closeDialog === 'function') {
          try { host.closeDialog(); } catch (err) {}
        }
      });
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        try { drawer.open(); } catch (err) {}
      }
    });
  }

  function boot() {
    document.querySelectorAll('opc-card').forEach(init);
    bindDrawerOpen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
